import { takeLatest } from 'redux-saga/effects';
import {
  CREATE_CALENDAR_DATE,
  CREATE_DAILY_TARIFF,
  CREATE_TARIFF,
  CALCULATE_TARIFF_COST,
  DELETE_CALENDAR_DATE,
  DELETE_DAILY_TARIFF,
  DELETE_TARIFF,
  EDIT_CALENDAR_DATE,
  EDIT_DAILY_TARIFF,
  EDIT_TARIFF,
  LOAD_CALENDAR_DATE_BY_ID,
  LOAD_CALENDAR_DATE_LIST,
  LOAD_DAILY_TARIFF_BY_ID,
  LOAD_DAILY_TARIFF_LIST,
  LOAD_LOST_TICKET_LIST,
  CREATE_LOST_TICKET,
  EDIT_LOST_TICKET,
  DELETE_LOST_TICKET,
  LOAD_TARIFF_BY_ID,
  LOAD_TARIFF_LIST,
} from '../actions';

import { TARIFF_MODULE } from '../../../configs/moduleNames';

import loadTariffList from './loadTariffList';
import createTariff from './createTariff';
import calculateTariffCost from './calculateTariffCost';
import editTariff from './editTariff';
import deleteTariff from './deleteTariff';
import loadTariffById from './loadTariffById';
import createCalendarDate from './createCalendarDate';
import editCalendarDate from './editCalendarDate';
import deleteCalendarDate from './deleteCalendarDate';
import loadCalendarDateList from './loadCalendarDateList';
import loadCalendarDateById from './loadCalendarDateById';
import loadDailyTariffList from './loadDailyTariffList';
import createDailyTariff from './createDailyTariff';
import editDailyTariff from './editDailyTariff';
import deleteDailyTariff from './deleteDailyTariff';
import loadDailyTariffById from './loadDailyTariffById';
import loadLostTicketList from './loadLostTicketList';
import createLostTicket from './createLostTicket';
import editLostTicket from './editLostTicket';
import deleteLostTicket from './deleteLostTicket';

export default function* sagas() {
  yield takeLatest(TARIFF_MODULE + CREATE_TARIFF, createTariff);
  yield takeLatest(TARIFF_MODULE + CALCULATE_TARIFF_COST, calculateTariffCost);
  yield takeLatest(TARIFF_MODULE + EDIT_TARIFF, editTariff);
  yield takeLatest(TARIFF_MODULE + DELETE_TARIFF, deleteTariff);
  yield takeLatest(TARIFF_MODULE + LOAD_TARIFF_LIST, loadTariffList);
  yield takeLatest(TARIFF_MODULE + LOAD_TARIFF_BY_ID, loadTariffById);

  yield takeLatest(TARIFF_MODULE + CREATE_CALENDAR_DATE, createCalendarDate);
  yield takeLatest(TARIFF_MODULE + EDIT_CALENDAR_DATE, editCalendarDate);
  yield takeLatest(TARIFF_MODULE + DELETE_CALENDAR_DATE, deleteCalendarDate);
  yield takeLatest(TARIFF_MODULE + LOAD_CALENDAR_DATE_LIST, loadCalendarDateList);
  yield takeLatest(TARIFF_MODULE + LOAD_CALENDAR_DATE_BY_ID, loadCalendarDateById);

  yield takeLatest(TARIFF_MODULE + CREATE_DAILY_TARIFF, createDailyTariff);
  yield takeLatest(TARIFF_MODULE + EDIT_DAILY_TARIFF, editDailyTariff);
  yield takeLatest(TARIFF_MODULE + DELETE_DAILY_TARIFF, deleteDailyTariff);
  yield takeLatest(TARIFF_MODULE + LOAD_DAILY_TARIFF_LIST, loadDailyTariffList);
  yield takeLatest(TARIFF_MODULE + LOAD_DAILY_TARIFF_BY_ID, loadDailyTariffById);

  yield takeLatest(TARIFF_MODULE + LOAD_LOST_TICKET_LIST, loadLostTicketList);
  yield takeLatest(TARIFF_MODULE + CREATE_LOST_TICKET, createLostTicket);
  yield takeLatest(TARIFF_MODULE + EDIT_LOST_TICKET, editLostTicket);
  yield takeLatest(TARIFF_MODULE + DELETE_LOST_TICKET, deleteLostTicket);
}
